import { useQuery } from '@tanstack/react-query';
import { fetchSettlementSummary, type SettlementSummary } from '@/lib/api';

/**
 * Settlement summary widget hook. Live: payout events refetch it
 * through LiveUpdatesProvider; no poll.
 */
export function useSettlementSummary() {
  return useQuery<SettlementSummary>({
    queryKey: ['dashboard', 'settlement-summary'],
    queryFn: fetchSettlementSummary,
    staleTime: 5 * 60 * 1000,
  });
}
